import angular from 'angular';
import AbstractTrack from './abstract.track';
import simpleTrackConfig from './simple-track-config';
import SimpleTrack from './simple-track';
const trackers = [];
const context = require.context('./tracks', true, /^(?!.*\.spec\.ts$).*(?:\.ts)$/);
context.keys().forEach((key) => {
    const module = context(key).default;
    if (module.prototype instanceof AbstractTrack)
        trackers.push(module);
});
export class DoxyAnalyticsService {
    constructor($injector) {
        this.$injector = $injector;
    }
    start() {
        trackers.forEach((trackClass) => {
            const tracker = new trackClass(this.$injector);
            tracker.start();
        });
        simpleTrackConfig.forEach((simpleTrackEvent) => {
            const tracker = new SimpleTrack(this.$injector, simpleTrackEvent);
            tracker.start();
        });
    }
}
export default angular
    .module('doxy.common.services.doxyAnalyticsService', [])
    .service('doxyAnalyticsService', DoxyAnalyticsService).name;
